import { useEffect, useState } from "react";
import { IoEyeSharp } from "react-icons/io5";
import axiosInstance from "../../api/axiosInstance.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import QuotesFiles from "./QuotesFiles.jsx";
import Select from "react-select";
import { FaStarOfLife } from "react-icons/fa";
import { notify, Toast } from "../../common/Toast/index.js";
import Loader from "../../common/Loader/index.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const ActiveDetails = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const permission = getUserMenuPermission(8);
  const navigate = useNavigate();
  const { quotationNo } = useParams();
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const { activeDetailsData } = location.state || {};
  const [quotationDetails, setQuotationDetails] = useState({
    quotationNo: 0,
    quotationDate: today,
    siteId: "",
    totalSqFt: "",
    remark: "",
    salePersonId: "",
    stageId: null,
    finalAmount: "",
    finalProfileColor: "",
    glassColorType: "",
    workCompleteDate: "",
    reason: "",
    quote_Amount: "",
  });

  const [files, setFiles] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isSiteDetailsData, setIsSiteDetailsData] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [salesPersons, setSalesPersons] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [displayNames, setDisplayNames] = useState({
    ownerName: "-",
    architectName: "-",
    fabricatorName: "-",
  });
  const userId = sessionStorage.getItem("userId");
  const userName = sessionStorage.getItem("userName");
  const { selectedSite } = location.state || {};

  useEffect(() => {
    fetchSiteDetails();

    if (selectedSite) {
      setQuotationDetails((prev) => ({
        ...prev,
        siteId: selectedSite.site_Id?.toString(),
      }));

      fetchDealDetails(selectedSite.site_Id);
    }
  }, []);

  const shouldShowCloseWonFields = (stageId) => {
    return [2, 6, 7].includes(stageId);
  };
  const isCloseWonEditable = (stageId) => {
    return stageId === 2;
  };

  const shouldShowCloseLostReason = (stageId) => {
    return stageId === 3;
  };

  useEffect(() => {
    if (quotationNo) {
      fetchQuotationDetails();
    }
  }, [quotationNo]);

  useEffect(() => {
    fetchSiteDetails();
    fetchSalePersons();
  }, []);

  useEffect(() => {
    if (siteDetails) {
      updateDisplayNames();
    }
  }, [siteDetails]);

  const validateForm = () => {
    const newErrors = {};
    if (!quotationDetails.quotationDate) {
      newErrors.quotationDate = "Quotation Date is required";
    }
    if (!quotationDetails.totalSqFt) {
      newErrors.totalSqFt = "Total_SqFt is required";
    }
    if (!quotationDetails.siteId) {
      newErrors.siteId = "Site Name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchSiteDetails = async () => {
    try {
      const { data } = await axiosInstance.get("SiteDetail/GetAll");
      setIsSiteDetailsData(data);
    } catch (error) {
      console.error("Error fetching site details:", error);
    }
  };
  const fetchSalePersons = async () => {
    try {
      const { data } = await axiosInstance.get("User/GetAllUser");
      setSalesPersons(data);
    } catch (error) {
      console.error("Error fetching Sale Person", error);
    }
  };
  const fetchQuotationDetails = async () => {
    try {
      const { data } = await axiosInstance.get(
        `WindowQuotation/GetWindowQuotationsWithFiles/${quotationNo}`
      );
      if (data.quotations?.length > 0) {
        const quotation = data.quotations[0];

        setQuotationDetails({
          quotationNo: quotation.quotation_No || "",
          quotationDate: quotation.quotation_Date?.split("T")[0] || "",
          totalSqFt: quotation.total_Sqft || "",
          siteId: quotation.site_Id || "",
          remark: quotation.remark || "",
          salePersonId: quotation.sale_Person_Id?.toString() || "",
        });

        setDisplayNames({
          ownerName: quotation?.owner_Name || "-",
          architectName: quotation?.architect_Name || "-",
          fabricatorName: quotation?.fabricator_Name || "-",
        });

        setFiles(
          (data.fileDetails || []).map((f) => ({
            ...f,
            is_Active: f.is_Active === true,
          }))
        );

        if (quotation.site_Id) {
          await fetchDealDetails(quotation.site_Id);
        }
      }
    } catch (error) {
      console.error("Error fetching quotation details:", error);
    }
  };
  const fetchDealDetails = async (siteId) => {
    try {
      const { data } = await axiosInstance.get(
        `SiteDetail/GetArchitectFabricatorOwnerBySite/${siteId}`
      );
      if (data) {
        setSiteDetails(data);
        setDisplayNames((prev) => ({
          ...prev,
          ownerName: data.owner_Name || "-",
          architectName: data.architect_Name || "-",
          fabricatorName: data.fabricator_Name || "-",
        }));
      }
    } catch (error) {
      console.error("Error fetching deal details:", error);
    }
  };

  const updateDisplayNames = () => {
    if (!siteDetails) return;

    setDisplayNames({
      ownerName: siteDetails.owner_Name || "-",
      architectName: siteDetails.architect_Name || "-",
      fabricatorName: siteDetails.fabricator_Name || "-",
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setQuotationDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (activeDetailsData && activeDetailsData.quotations?.length > 0) {
      const quotation = activeDetailsData.quotations[0];

      setQuotationDetails((prev) => ({
        ...prev,
        quotationNo: quotation.quotation_No || "",
        quotationDate: quotation.quotation_Date
          ? quotation.quotation_Date.split("T")[0]
          : "",
        totalSqFt: quotation.total_Sqft || "",
        siteId: quotation.site_Id || "",
        remark: quotation.remark || "",
        salePersonId: quotation.sale_Person_Id?.toString() || "",
        stageId: quotation.stage_Id,
        finalAmount: quotation.final_Amount || "",
        finalProfileColor: quotation.final_Profile_Color || "",
        glassColorType: quotation.glass_Color_Type || "",
        workCompleteDate: quotation.work_Complete_Date?.split("T")[0] || "",
        reason: quotation.reason || "",
      }));

      if (activeDetailsData.fileDetails?.length) {
        setFiles(activeDetailsData.fileDetails);
      }
      setDisplayNames({
        ownerName: quotation.owner_Name || "-",
        architectName: quotation.architect_Name || "-",
        fabricatorName: quotation.fabricator_Name || "-",
      });
      setIsEditing(true);
    }
  }, [activeDetailsData]);

  const handleSiteChange = async (selectedOption) => {
    if (!selectedOption) {
      setQuotationDetails((prev) => ({
        ...prev,
        siteId: "",
      }));
      return;
    }

    const siteId = selectedOption.value;
    setQuotationDetails((prev) => ({
      ...prev,
      siteId,
    }));

    if (siteId === "add-new") {
      // setIsModelOpen(true);
      navigate("/transaction/site-details");
    } else {
      await fetchDealDetails(siteId);
    }
  };

  useEffect(() => {
    if (quotationDetails.siteId && isSiteDetailsData.length > 0) {
      const selectedSite = isSiteDetailsData.find(
        (site) => site.site_Id.toString() === quotationDetails.siteId.toString()
      );
      if (selectedSite) {
        setQuotationDetails((prev) => ({
          ...prev,
          siteId: selectedSite.site_Id.toString(),
        }));
      }
    }
  }, [isSiteDetailsData, quotationDetails.siteId]);

  const handleViewSiteDetails = () => {
    if (!siteDetails) return;

    navigate("/transaction/site-details", {
      state: { siteData: siteDetails, isReadOnly: true },
    });
  };
  useEffect(() => {
    if (!quotationNo && !isEditing) {
      setQuotationDetails((prev) => ({
        ...prev,
        salePersonId: prev.salePersonId || userId,
      }));
    }
  }, [quotationNo, isEditing]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    if (!validateForm()) {
      return;
    }
    try {
      const payload = {
        Quotation_Date: quotationDetails.quotationDate
          ? new Date(quotationDetails.quotationDate).toISOString()
          : null,
        Site_Id: quotationDetails.siteId
          ? parseInt(quotationDetails.siteId)
          : null,
        Total_Sqft: parseFloat(quotationDetails.totalSqFt) || 0,
        Remark: quotationDetails.remark || "",
        Sale_Person_Id: quotationDetails.salePersonId
          ? parseInt(quotationDetails.salePersonId)
          : null,
        Quote_Amount: quotationDetails.quote_Amount || "0.00",
        Updated_By: userId,
        Created_By: userId,
        ...(Number(quotationDetails.stageId) === 2 && {
          Final_Amount: quotationDetails.finalAmount,
          Final_Profile_Color: quotationDetails.finalProfileColor,
          Glass_Color_Type: quotationDetails.glassColorType,
          Work_Complete_Date: quotationDetails.workCompleteDate
            ? new Date(quotationDetails.workCompleteDate).toISOString()
            : null,
        }),
        ...(Number(quotationDetails.stageId) === 3 && {
          Reason: quotationDetails.reason,
        }),
      };

      if (quotationDetails.quotationNo) {
        payload.Quotation_No = quotationDetails.quotationNo;
      }

      const response = await axiosInstance.post(
        "WindowQuotation/SaveUpdateQuotation",
        payload
      );

      if (response.status === 200) {
        if (files.length > 0) {
          await handleSaveFiles({ quotationNo: response.data.quotationNo });
        }
        notify(
          isEditing
            ? "Window Quotation updated successfully!"
            : "Window Quotation added successfully!",
          "success"
        );
        setTimeout(() => navigate("/quotes/window-quotation"), 1000);
      }
    } catch (error) {
      notify("Error saving quotation:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveFiles = async ({ quotationNo }) => {
    try {
      for (const file of files) {
        const isNewFile = !!file.file && !file.seq_No;
        const attachDate = new Date(file.attach_Date)
          .toISOString()
          .split("T")[0];
        if (isNewFile && Number(quotationNo) === 0) {
          const formData = new FormData();
          formData.append("Quotation_No", quotationNo);
          formData.append("Seq_No", file.Seq_No || 0);
          formData.append("File_Name", file.file);
          formData.append("Attach_Date", attachDate);
          formData.append("Quote_Amount", file.quote_Amount || 0);
          formData.append("Is_Active", file.is_Active ? 1 : 0);
          formData.append("Created_By", userId);

          await axiosInstance.post("WindowQuotation/SaveFileDetail", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
        if (isNewFile && Number(quotationNo) > 0) {
          const formData = new FormData();
          formData.append("Seq_No", file.Seq_No || 0);
          formData.append("Quotation_No", quotationNo);
          formData.append("File_Name", file.file);
          formData.append("Attach_Date", attachDate);
          formData.append("Quote_Amount", file.quote_Amount || 0);
          formData.append("Is_Active", file.is_Active ? 1 : 0);
          formData.append("Created_By", userId);

          await axiosInstance.post("WindowQuotation/SaveFileDetail", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }

        if (!isNewFile && file.seq_No) {
          const payload = {
            Seq_No: file.seq_No,
            Quotation_No: quotationNo,
            File_Name_Path: file.file_Name_Path || file.file_Name,
            Attach_Date: attachDate,
            Quote_Amount: Number(file.quote_Amount || 0),
            Is_Active: file.is_Active ? 1 : 0,
            Modified_By: 5,
          };

          await axiosInstance.post("WindowQuotation/UpdateFileDetail", payload);
        }
      }
    } catch (error) {
      console.error("🚨 Error updating/saving files:", error);
      notify("Error while saving or updating files", "error");
    }
  };
  const options = [
    ...isSiteDetailsData.map((site) => ({
      value: site.site_Id?.toString() || "",
      label: site.site_Name || "Unnamed Site",
    })),
    { value: "add-new", label: "+ Add New Site Details" },
  ];
  const salePersonOptions = salesPersons.map((per) => ({
    value: String(per.sale_Person_Id),
    label: per.Sale_Person_Name,
  }));

  return (
    <>
      <Toast />
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <h1 className="text-lg font-bold">Window Details</h1>
              </div>
              <button
                className="px-6 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-secondary"
                onClick={() => navigate(`/quotes/window-quotation`)}
              >
                Back
              </button>
            </div>
            <form className="space-y-6 " onSubmit={handleSubmit}>
              <div className="bg-white p-6 border-4 border-[#f1f4f9] rounded-lg shadow-md">
                <div className="p-4">
                  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div className="flex flex-col">
                      <label className="text-sm font-medium">
                        Quotation No
                      </label>
                      <input
                        id="quotationNo"
                        name="quotationNo"
                        type="text"
                        value={quotationDetails.quotationNo}
                        onChange={handleChange}
                        disabled
                        className="mt-1 block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                      />
                    </div>
                    <div className="relative w-full">
                      {/* <QuotationDatePicker
                        quotation={quotationDetails}
                        setQuotation={setQuotationDetails}
                        errors={errors}
                      /> */}
                      <label className="text-sm font-medium">
                        Quotation Date
                      </label>
                      <input
                        id="quotationDate"
                        name="quotationDate"
                        type="date"
                        value={quotationDetails.quotationDate}
                        onChange={handleChange}
                        onFocus={(e) => e.target.showPicker()}
                        className={`mt-1 block w-full rounded-md border border-gray shadow-sm py-2 px-3 outline-none focus:ring-2 focus:ring-primary focus:border-primary  ${
                          errors.quotation_Date
                            ? "border-red-500"
                            : "border-gray-300"
                        }`}
                      />
                    </div>
                    <div className="flex flex-col">
                      <div className="relative">
                        <div className="flex items-center ">
                          <div className="flex items-center gap-2">
                            <label className=" text-sm font-medium">
                              Site Name
                            </label>
                            <button
                              type="button"
                              onClick={handleViewSiteDetails}
                              className="cursor-pointer"
                            >
                              <IoEyeSharp className="w-5 h-5" />
                            </button>
                          </div>
                          <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />{" "}
                        </div>
                        <Select
                          options={options}
                          value={
                            quotationDetails.siteId
                              ? options.find(
                                  (option) =>
                                    option.value === quotationDetails.siteId
                                ) || null
                              : null
                          }
                          // isDisabled={!!selectedSite}
                          isClearable
                          isSearchable
                          onChange={handleSiteChange}
                          className="mt-1"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              borderColor: errors.siteId
                                ? "#ef4444"
                                : "#e5e7eb",
                              boxShadow: "none",
                              "&:hover": { borderColor: "gray" },
                            }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "300px",
                              overflowY: "auto",
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: "300px",
                              overflowY: "auto",
                            }),
                            option: (provided, { data }) => ({
                              ...provided,
                              backgroundColor:
                                data.value === "add-new"
                                  ? "#F3F4F6"
                                  : provided.backgroundColor,
                              fontWeight:
                                data.value === "add-new" ? "bold" : "normal",
                              cursor: "pointer",
                              position:
                                data.value === "add-new"
                                  ? "sticky"
                                  : "relative",
                              bottom: data.value === "add-new" ? "0" : "auto",
                            }),
                          }}
                        />
                        {errors.siteId && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.siteId}
                          </p>
                        )}
                      </div>
                      <div className="grid gap-2 text-sm font-medium p-2 mt-2">
                        <div className="grid grid-cols-2 gap-2">
                          <span>Owner :</span>
                          <span>{displayNames.ownerName}</span>
                        </div>
                        <div className="grid grid-cols-2 gap-2">
                          <span>Architect :</span>
                          <span>{displayNames.architectName}</span>
                        </div>
                        <div className="grid grid-cols-2 gap-2">
                          <span>Fabricator :</span>
                          <span>{displayNames.fabricatorName}</span>
                        </div>
                      </div>
                    </div>
                    <div className="relative">
                      <label className="flex items-center text-sm font-medium mb-1">
                        Total SqFt
                        <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                      </label>
                      <input
                        id="totalSqFt"
                        name="totalSqFt"
                        type="text"
                        value={quotationDetails.totalSqFt}
                        onChange={handleChange}
                        className={`w-full border rounded p-2 outline-none focus:ring-1 ${
                          errors.totalSqFt
                            ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                            : "border-gray-300 focus:ring-primary focus:border-primary"
                        }`}
                      />
                      {errors.totalSqFt && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.totalSqFt}
                        </p>
                      )}
                      <div>
                        <label className="block text-md font-medium mb-1 mt-2">
                          Sale Person
                        </label>

                        {userId === "1" ? (
                          <Select
                            options={salePersonOptions}
                            value={
                              salePersonOptions.find(
                                (option) =>
                                  String(option.value) ===
                                  String(quotationDetails.salePersonId)
                              ) || null
                            }
                            isClearable
                            isSearchable
                            onChange={(selectedOption) =>
                              setQuotationDetails((prev) => ({
                                ...prev,
                                salePersonId: selectedOption
                                  ? selectedOption.value
                                  : "",
                              }))
                            }
                            className="mt-1"
                          />
                        ) : (
                          <input
                            type="text"
                            value={
                              salePersonOptions.find(
                                (person) =>
                                  String(person.value) ===
                                  String(quotationDetails.salePersonId)
                              )?.label || "-"
                            }
                            disabled
                            className="mt-1 block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <QuotesFiles
                files={files}
                setFiles={setFiles}
                isEditing={isEditing}
              />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white rounded-lg shadow-md space-y-4">
                  <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                    <h2 className="text-base font-semibold text-[#405189]">
                      Notes
                    </h2>
                  </div>
                  <div className="p-4">
                    <label className=" text-md ">Remarks</label>
                    <textarea
                      id="remark"
                      rows="4"
                      name="remark"
                      value={quotationDetails.remark}
                      onChange={handleChange}
                      className="mt-2 block w-full rounded border border-gray-300 px-4 py-2 shadow-sm focus:ring-1 focus:ring-primary focus:border-primary outline-none break-words"
                      placeholder="Enter your remarks..."
                    ></textarea>
                  </div>
                </div>
                <div
                  className={` ${
                    Number(quotationDetails.quotationNo) === 0 ||
                    Number(quotationDetails.stageId) === 1
                      ? "hidden"
                      : "bg-white rounded-lg shadow-md p-6 space-y-4 "
                  }`}
                >
                  {shouldShowCloseWonFields(
                    Number(quotationDetails.stageId)
                  ) && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <label className="block text-md font-medium mt-2">
                        Final Amount
                      </label>
                      <input
                        type="text"
                        name="finalAmount"
                        value={quotationDetails.finalAmount || ""}
                        onChange={handleChange}
                        disabled={
                          !isCloseWonEditable(Number(quotationDetails.stageId))
                        }
                        className="block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                      />

                      <label className="block text-md font-medium">
                        Final Profile Color
                      </label>
                      <input
                        type="text"
                        name="finalProfileColor"
                        value={quotationDetails.finalProfileColor || ""}
                        onChange={handleChange}
                        disabled={
                          !isCloseWonEditable(Number(quotationDetails.stageId))
                        }
                        className="block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                      />

                      <label className="block text-md font-medium">
                        Glass Color Type
                      </label>
                      <input
                        type="text"
                        name="glassColorType"
                        value={quotationDetails.glassColorType || ""}
                        onChange={handleChange}
                        disabled={
                          !isCloseWonEditable(Number(quotationDetails.stageId))
                        }
                        className="block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                      />

                      <label className="block text-md font-medium">
                        Close Won Date
                      </label>
                      <input
                        type="date"
                        name="closeWonDate"
                        value={quotationDetails.workCompleteDate || ""}
                        onChange={handleChange}
                        disabled={
                          !isCloseWonEditable(Number(quotationDetails.stageId))
                        }
                        className="block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                      />
                    </div>
                  )}
                  {shouldShowCloseLostReason(
                    Number(quotationDetails.stageId)
                  ) && (
                    <>
                      <label className="block text-md font-medium mb-1 mt-2">
                        Reason
                      </label>
                      <textarea
                        name="reason"
                        value={quotationDetails.reason || ""}
                        onChange={handleChange}
                        rows="4"
                        className="mt-2 block w-full rounded border border-gray-300 px-4 py-2 shadow-sm focus:ring-primary focus:border-primary break-words"
                        placeholder="Enter reason here..."
                      ></textarea>
                    </>
                  )}
                </div>
              </div>
              <div className="flex gap-4">
                {(isEditing ? permission.isUpdate : permission.isInsert) && (
                  <button
                    className="px-6 py-2 border border-transparent text-sm font-medium rounded text-white bg-primary"
                    type="submit"
                  >
                    {isEditing ? "Update" : "Save"}
                  </button>
                )}
                <button
                  type="button"
                  className="px-4 py-2 border border-gray text-sm font-medium rounded bg-white"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </>
  );
};

export default ActiveDetails;
